import styled from "styled-components";

const Container = styled.div`
  width: 200px;

  color: var(--element);

  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  gap: 20px;

  &:hover {
    transform: translateY(-6px);
  }
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;

  gap: 5px;
  width: 90%;
  margin-bottom: 20px;
`;

const NumberCircle = styled.div`
  width: 130px;
  height: 130px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    2px 2px #44be30,
    5px 5px #196a07;
  background: var(--mainGradient);
  font-weight: 900;
  font-size: 24px;
  font-family: var(--headingFont);
`;

const Title = styled.div`
  width: 100%;
  font-weight: 900;
  font-size: 18px;
  text-align: center;
  font-family: var(--headingFont);
`;

const Description = styled.div`
  width: 100%;
  text-align: center;
  font-size: 15px;
  opacity: 0.7;
`;

export default function CompanyStatCard({ title, description, numberText }) {
  return (
    <Container>
      <NumberCircle>{numberText}</NumberCircle>

      <Text>
        <Title>{title}</Title>
        {description ? <Description>{description}</Description> : null}
      </Text>
    </Container>
  );
}
